import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        labelCheckbox: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        checkbox: {
            paddingTop: '0 !important',
        },
        chip: {
            '&&': {
                backgroundColor: theme.palette.secondary[200],
                color: theme.palette.secondary[600],
            },
        },
    }
})

export default useStyles
